export const enum ThemeTextColor {
  Default = 'sys.neutral.text.default',
  Active = 'sys.neutral.text.active',
  Placeholder = 'sys.neutral.text.default',
  Focus = 'sys.secondary.background.hover',
  Error = 'sys.error.text.default',
  Warning = 'sys.warning.background.default',
  Success = 'sys.success.background.default',
}

export const enum ThemeBorderColor {
  Default = 'sys.neutral.border.default',
  Active = 'sys.neutral.border.active',
  Error = 'sys.error.border.default',
  Warning = 'sys.warning.border.default',
  Success = 'sys.success.border.default',
}
